<app-title-section></app-title-section>
<app-parametre-bar></app-parametre-bar>
<div class="card p-1" style="margin: 0 60px;">

    <div class="d-flex justify-content-between align-items-center">

        <div class="d-flex align-items-center">
            <ng-container>
                <img [src]="file" class="logo-img me-2" style="width: 35px;height: auto">
                <p style="font-size: 22px;color: #2F2B3DE5">{{ '' | enterpriseName }}</p>
            </ng-container>

        </div>

        <label > <strong class="size20">Facture
            / </strong> <label class="text-muted size20"> FAC-000001</label>  </label>


    </div>

    <!-- Ligne 2 : Client à gauche / Détails du document à droite -->
    <div class="items mt-4">
        <div class="flex-grow-1" style="margin-left: 36px">
            <p style="font-size: 15px;color:#2F2B3DE5;font-weight: 700">Client </p>
            <hr class="section-line" style="border-bottom: 1px solid rgba(19, 74, 211, 1)">


            <div class="d-flex ">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Nom du client</label></td>
                        <td><label class="size15-400">Ahmed krichen </label></td>
                    </tr>
                </table>
            </div>
            <hr>
            <div class="d-flex ">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Identifiant unique</label></td>
                        <td><label class="size15-400">CP 5 </label></td>
                    </tr>
                </table>

            </div>
            <hr>
            <div class="d-flex">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Adresse</label></td>
                        <td><label class="size15-400">--</label></td>
                    </tr>
                </table>

            </div>
            <hr>
            <div class="d-flex ">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Email</label></td>
                        <td><label class="size15-400">--</label></td>
                    </tr>
                </table>
            </div>
            <hr>


        </div>
        <!-- Partie Détails du document -->
        <div class="flex-grow-1">
            <p style="font-size: 15px;color:#2F2B3DE5;font-weight: 700">Détails du document </p>
            <hr class="section-line" style="border-bottom: 1px solid rgba(19, 74, 211, 1)">


            <div class="d-flex " >
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Date</label></td>
                        <td><label class="size15-400"> 19/08/2025 </label></td>
                    </tr>
                </table>


            </div>
            <hr>
            <div class="d-flex ">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Entrepôt</label></td>
                        <td><label class="size15-400"> -- </label></td>
                    </tr>
                </table>

            </div>
            <hr>


            <div class="d-flex">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Projet</label></td>
                        <td><label class="size15-400"> -- </label></td>
                    </tr>
                </table>

            </div>
            <hr>
            <div class="d-flex " >
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Note</label></td>
                        <td><label class="size15-400"> -- </label></td>
                    </tr>
                </table>

            </div>
            <hr>


        </div>
    </div>


    <div class="products-section">
        <table class="products-table ">
            <thead style="height: 56px; background-color: #134AD329">
            <tr>
                <th>DÉSIGNATION</th>
                <th>QUANTITÉ</th>
                <th>QUANTITÉ DISPONIBLE</th>
                <th> VALEUR UNITAIRE</th>
                <th>TOTAL HT</th>
            </tr>
            </thead>
            <tr>
                <td>Blazer</td>
                <td>1000</td>
                <td>420,16TND</td>
                <td>13</td>
                <td>420,168TND</td>
            </tr>
            <tr>
                <td>Blazer</td>
                <td>1000</td>
                <td>420,16TND</td>
                <td>13</td>
                <td>420,168TND</td>
            </tr>
            <tbody>

            </tbody>
        </table>


    </div>

    <div class="d-flex align-items-start justify-content-between mt-4">
        <div class="" style="position: relative; left: 50%; transform: translateX(-80%);">
            <table class="products-table" style="width: 400px;">
                <thead style="height: 56px; background-color: rgba(19, 74, 211, 0.16);">
                <tr>
                    <th>TVA</th>
                    <th>BASE</th>
                    <th>MONTANT</th>
                </tr>

                </thead>
                <tbody>
                <tr>
                    <td>0</td>
                    <td>420,168TND</td>
                    <td>0,000TND</td>
                </tr>
                <tr *ngFor="let tva of tvaSummary">
                    <td class="table-input">{{tva.rate}}%</td>
                    <td class="table-input">{{tva.base | number:'1.3-3'}} TND</td>
                    <td class="table-input">{{tva.amount | number:'1.3-3'}} TND</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div style="position: relative; width: 100%; max-width: 400px; margin-left: auto;margin-right: 50px;">
            <table class="table table-borderless text-start rounded totals-table">
                <tbody>
                <tr>
                    <td>Total HT</td>
                    <td>{{totals.totalHT | number:'1.3-3'}} TND</td>
                </tr>
                <tr>
                    <td>Total TVA</td>
                    <td>{{totals.totalTVA | number:'1.3-3'}} TND</td>
                </tr>
                <tr>
                    <td>Total TTC</td>
                    <td>{{totals.totalTTC | number:'1.3-3'}} TND</td>
                </tr>
                <tr>
                    <td>Timbre fiscal</td>
                    <td>0.600 TND</td>
                </tr>
                <tr class="fw-bold">
                    <td>Net à payer</td>
                    <td>{{(totals.totalTTC + 0.600) | number:'1.3-3'}} TND</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Footer Info -->
    <div class="footer-info d-flex justify-content-between">
        <div class="company-info">
            <p class="size15"><strong>Entreprise </strong></p>
            <p class="information">Shopi</p>
            <p class="information">l'aouina cité wahat, tunis</p>
            <p class="information">null tunis</p>
            <p class="information">Matricule fiscal: 5885</p>
        </div>
        <div class="coordinates">
            <p class="size15"><strong> Coordonnées </strong></p>
            <p class="information">--</p>
            <p class="information">--</p>
        </div>
        <div class="bank-info">
            <p class="size15"><strong> Coordonnées bancaires </strong></p>
            <p class="information">STB-Société Tunisienne de Banque</p>
            <p class="information">TN5910006035183509478831</p>
        </div>
    </div>


</div>












